import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import ErrorFallback from '../components/ErrorFallback/ErrorFallback';

// :: Hooks
import useDarkMode from '../hooks/useDarkMode';

// :: Images
import { FourSquaresColor, FourSquaresColorWhite } from '../images/shapes';

import Structure from './Structure';

const LayoutSlim = ({ children, testId }) => {
  const { t } = useTranslation();
  const [darkMode] = useDarkMode();

  const SIDEBAR_MENU_ITEMS = useMemo(
    () => [
      {
        key: 'dashboard',
        icon: darkMode ? (
          <FourSquaresColorWhite className="w-6 min-w-6" />
        ) : (
          <FourSquaresColor className="w-6 min-w-6" />
        ),
        title: t('Global.Dashboard'),
        link: `/`,
      },
    ],
    [darkMode, t],
  );

  const getErrorFallbackPage = (event) => <ErrorFallback {...event} />;

  return (
    <Sentry.ErrorBoundary fallback={getErrorFallbackPage}>
      <Structure sidebarMenuItems={SIDEBAR_MENU_ITEMS} testId={testId}>
        {children ? children : <Outlet />}
      </Structure>
    </Sentry.ErrorBoundary>
  );
};

export default LayoutSlim;

LayoutSlim.propTypes = {
  /**
   * Test id for layout
   */
  testId: PropTypes.string,
};
